import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MD5UtilService } from './MD5Util.service';

@Injectable({
  providedIn: 'root'
})
export class MtbService {

  constructor(private http: HttpClient,private md5Util:MD5UtilService) { }

  sendOtp(value,transactiontype,userCurrenPosition){
    console.log(value);
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    var md5key=localStorage.getItem('md5key');
    console.log("md5key:::::::::",md5key)
    var checkSum = this.md5Util.getMd5Checksum(value.amount+value.comments+md5key);

    console.log("checkSum::::::::::",checkSum);

    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('checkSum',checkSum.toString());
    headers = headers.append('apikey', environment.api_key);
   
    const params ={
      amount: value.amount,
      comments: value.comments,
      latitute: userCurrenPosition.latitude,
      longitute: userCurrenPosition.longitude,
      remarks: value.comments,
   
    }
    console.log("checkSum::::::::::params",params);

    return this.http.post(`${environment.walletUrl}/ym/retailor/move/tobankaccount/init?transactiontype=${transactiontype}&otpOn=${value.otpOn}`, params,{ headers: headers });
  }
  resendOtp(uniqueTransactionNumber){
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
   
    return this.http.get(`${environment.walletUrl}/ym/retailor/move/tobankaccount/resend/${uniqueTransactionNumber}`, { headers: headers });
  }

  movetobank(form,uniqueTransactionNumber) {
    // let agentId = JSON.parse(localStorage.getItem('currentUser')).data.agentId;
    console.log(form);
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data.walletToken;
    var token = localStorage.getItem('wallet-token');
    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
   
    var receieved_otp = this.md5Util.getMd5Checksum(form.otp+uniqueTransactionNumber);

    var data={
      otp: receieved_otp.toString()
    }
    return this.http.post(`${environment.walletUrl}/ym/retailor/move/tobankaccount/validate`, data, { headers: headers })
  }
 
}
